import { render, staticRenderFns } from "./FreetComponent.vue?vue&type=template&id=40ec617c&scoped=true&"
import script from "./FreetComponent.vue?vue&type=script&lang=js&"
export * from "./FreetComponent.vue?vue&type=script&lang=js&"
import style0 from "./FreetComponent.vue?vue&type=style&index=0&id=40ec617c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ec617c",
  null
  
)

export default component.exports